<div class="flex-vertical gap-16 width-100pc">
  <div class="flex-horizontal flex-center gap-16">
    <div>
      {{ totalCount }} @if (totalCount > 1) {
      <span>demandes</span>
      }@if (totalCount < 2) {
      <span>demande</span>
    }
  </div>
  @if (withRefresh) {
    <oui-button (click)="onRefresh.emit()" type="text" iconPrefix="cached"
    size="small">Actualiser</oui-button>
  }
</div>
<div class="width-100pc">
  @if (!isLoading && dataSource.data.length > 0) {
    <oui-table>
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="columnSelection[0].header" matSortDirection="asc">
        @for (columnconfig of columnSelection; track columnconfig) {
          <ng-container matColumnDef="{{ columnconfig.header }}">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="{{ columnconfig.header }}">
              @if (columnconfig.header === 'ActionConsultant' || columnconfig.header === 'ActionBackOffice') {
              } @else {
                {{ columnconfig.header }}
              }
            </th>
            <td mat-cell *matCellDef="let creation">
              @switch (columnconfig.header) {
                @case ('ActionConsultant') {
                  @if (displaycellValue(columnconfig, creation) === 'true') {
                    <oui-button style="width: 100%" type="text" (click)="declareSouscription(creation)">Déclarer une souscription</oui-button>
                  }
                }
                @case ('Statut') {
                  <lib-creation-personne-morale-statut-cell [creation]="creation"></lib-creation-personne-morale-statut-cell>
                }
                @case ('ActionBackOffice') {
                  <oui-button style="width: 100%" type="text" iconPrefix="check_small" (click)="onValidCreation(creation)">Valider</oui-button>
                }
                @default {
                  <div style="white-space: pre-line">
                    {{ displaycellValue(columnconfig, creation) }}
                  </div>
                }
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </ng-container>
      </table>
    </oui-table>
  }
  @if (isLoading || dataSource.data.length === 0) {
    <div class="etat-vide-container">
      @if (!isLoading) {
        <oui-etat-vide title="Aucun résultat" icon="live_help"></oui-etat-vide>
      }
      @if (isLoading) {
        <oui-loading></oui-loading>
      }
    </div>
  }
</div>
</div>